export const DATABAR_SCHEMA = {
  en: {
    card_1: {
      title: "Starts With You",
      description: "Because no two financial lives are alike.",
    },
    card_2: {
      title: "The Bigger Picture",
      description: "One detail never tells the whole story.",
    },
    card_3: {
      title: "One Connected Place",
      description: "Everything working around your financial life.",
    },
  },
};
